import { createSelector } from 'reselect'

import { selectQueryParams } from 'selectors/location'

export default createSelector(
  selectQueryParams,
  params => params.error !== undefined
)
